import { render } from "./MenuMaker.vue?vue&type=template&id=4cc41e84&scoped=true"
import script from "./MenuMaker.vue?vue&type=script&lang=js"
export * from "./MenuMaker.vue?vue&type=script&lang=js"

import "./MenuMaker.vue?vue&type=style&index=0&id=4cc41e84&lang=scss&scoped=true"

import exportComponent from "/Users/johnahnz0rs/0-PROJECTS/stackin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc41e84"]])

export default __exports__